export default function getPrimary(id) {
  switch(id) {
    case 'QkaQHG5U1yhPGQBa4bX3': return '#228B22';
    case 'GH2CCtKRoiU0fkZq4pzZ': return '#228B22';
    case 'z9VALcDLcbhMlfOSEnUV': return '#EE82EE';
    case 'pwaV5P3ATIYUxkl7WSAb': return '#00BFFF';
    case 'XgLPT7zlVTiOYZ4scAbR': return '#DC143C';
    case '9DYY5U4yCzOXR3NDxV5N': return '#DAA520';
    case 'Og7AHkKWFh8T8WlNj9Uk': return '#800080';
    default: return 'transparent';
  }
}